import { useMemo } from "react";
import { useAuth, useTellescopeCountQuery } from "@tellescope/tanstack-query";
import { useInboxTableViews } from "../../../../hooks";
import { useCareTeamEnduserIds } from "../../../../pages/messaging/hooks";
import { buildInboxUnreadCountMdbFilter } from "../../../../pages/messaging/utils";

export const InboxUnreadCountBadge = () => {
  const { currentUser } = useAuth();
  const { effectiveFilters } = useInboxTableViews();
  const { enduserIds: careTeamEnduserIds, isLoading: isLoadingCareTeam } = useCareTeamEnduserIds(
    effectiveFilters.careTeamIds
  );

  const mdbFilter = useMemo(
    () => buildInboxUnreadCountMdbFilter(effectiveFilters, currentUser.id),
    [effectiveFilters, currentUser.id]
  );

  const query = useTellescopeCountQuery({
    model: "inbox_threads",
    method: "load_threads",
    request: {
      autobuild: true,
      mdbFilter,
      enduserIds: careTeamEnduserIds,
    },
    enabled: !isLoadingCareTeam,
    select: (data) => data.count,
  });

  if (!query.data) {
    return null;
  }

  return <p className="text-muted-foreground">{query.data}</p>;
};
